import React, { useState } from 'react';
import './SinglePdfUpload.css';

function AnalysisUpload({ onFileUpload, onBack }) {
  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf') {
        handleFileAnalysis(file);
      } else {
        alert('Please upload a PDF file');
      }
    }
  };

  const handleFileInput = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf') {
        handleFileAnalysis(file);
      } else {
        alert('Please upload a PDF file');
      }
    }
  };

  const handleFileAnalysis = async (file) => {
    setIsUploading(true);

    try {
      // Create FormData to send the PDF file
      const formData = new FormData();
      formData.append('file', file);

      console.log('Uploading PDF for analysis:', file.name);

      // Send to our proxy endpoint which forwards to Python backend
      const response = await fetch('/api/analysis/analyze-pdf', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Analysis failed');
      }

      const analysisResult = await response.json();
      console.log('Analysis result:', analysisResult);

      // Pass the analysis result up to parent component
      // The result contains { data: {...}, conflicts: {...} }
      onFileUpload(file, analysisResult);

    } catch (error) {
      console.error('Analysis error:', error);
      alert(`Failed to analyze PDF: ${error.message}`);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="single-pdf-upload">
      <div className="upload-header">
        <div>
          <h2>Title Document Analysis</h2>
          <p className="upload-subtitle">Upload title commitment or purchase agreement to automatically extract and pre-fill order information</p>
        </div>
      </div>

      <div
        className={`drop-zone ${isDragging ? 'dragging' : ''} ${isUploading ? 'uploading' : ''}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <div className="drop-zone-content">
          {isUploading ? (
            <>
              <div className="upload-icon">⏳</div>
              <h3>Analyzing document...</h3>
              <p className="drop-zone-subtitle">This may take a moment</p>
            </>
          ) : (
            <>
              <div className="upload-icon">📄</div>
              <h3>Drag and drop your title document here</h3>
              <p className="drop-zone-subtitle">or</p>
              <label htmlFor="analysis-file-input" className="upload-button">
                Browse Files
              </label>
              <input
                id="analysis-file-input"
                type="file"
                accept=".pdf"
                onChange={handleFileInput}
                style={{ display: 'none' }}
                disabled={isUploading}
              />
              <p className="file-info">Accepts PDF files only</p>
            </>
          )}
        </div>
      </div>

      <div className="process-info">
        <h3>How it works:</h3>
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h4>Upload Title Document</h4>
              <p>Drag and drop or browse for your title commitment or purchase agreement PDF</p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h4>Dual AI Analysis</h4>
              <p>Azure OpenAI and Claude extract property, parties, and commitment information in parallel</p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h4>Review Results</h4>
              <p>Compare AI consensus side-by-side, resolve conflicts, and edit fields as needed</p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h4>Submit to SoftPro</h4>
              <p>Send validated order data directly to SoftPro for order creation</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnalysisUpload;
